import { Stack } from "@mui/material";
import { TextBlock } from "./TextBlock";

export const OlList = ({ text }: { text: string[] }) => {
  if (!text || !Array.isArray(text)) return null;

  return (
    <Stack gap="8px">
      {text.map((el, i) => (
        <Stack gap="8px" flexDirection="row" alignItems="flex-start" key={el}>
          <Stack
            alignItems="center"
            justifyContent="center"
            height="24px"
            minWidth="12px"
          >
            {i + 1}.
          </Stack>

          <TextBlock text={[el]} />
        </Stack>
      ))}
    </Stack>
  );
};
